/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from 'antd';
import { Popup } from 'devextreme-react';
import ScrollView from 'devextreme-react/scroll-view';
import moment from 'moment';

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import Utils from '../../Assets/Scripts/Utils';
import SchedulingFunctions from '../../Pages/ScheduleConecta/API/SchedulingFunctions';
import { api } from '../../Services/axiosService';

import './NewSlotPopup.scss';

const { TextArea } = Input;

export default function NewSlotPopup({
  newSlotPopupRef,
  slots,
  setSlots,
  getCurrentDate,
  trainingCenter,
  bitrixProducts,
  callSlotGeneration,
}) {
  const [form] = Form.useForm();
  const [formList] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [resourceOptions, setResourceOptions] = useState([]);
  const [maxSlots, setMaxSlots] = useState(0);

  const ctId = parseInt(
    JSON.parse(localStorage.getItem('conecta__scheduleData'))?.trainingCenterId,
    10
  );
  const showFooterButtons =
    JSON.parse(localStorage.getItem('conecta__userData'))?.isApprover && slots.length > 0;

  const processSlots = (slotArray) => {
    if (!slotArray) return [];
    return slotArray.map((item) => ({
      ...item,
      key: item.id,
      trainingCenterName: trainingCenter?.name || 'N/A',
    }));
  };

  useEffect(() => {
    const initialSlotsProcessed = processSlots(slots);
    if (JSON.stringify(initialSlotsProcessed) !== JSON.stringify(slots)) {
      setSlots(initialSlotsProcessed);
    }
  }, [trainingCenter]);

  const getColumnSearchProps = (dataIndex, title, isDate = false) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8, borderRadius: '6px' }}>
        {isDate ? (
          <DatePicker
            onChange={(date, dateString) => setSelectedKeys(dateString ? [dateString] : [])}
            format="DD/MM/YYYY"
            style={{ marginBottom: 8, display: 'block' }}
            placeholder={`Buscar ${title}`}
            value={selectedKeys[0] ? moment(selectedKeys[0], 'DD/MM/YYYY') : null}
          />
        ) : (
          <Input
            placeholder={`Buscar ${title}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: 'block' }}
          />
        )}
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Filtrar
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (value === undefined || value === null || value === '') return true;
      const recordValue = record[dataIndex];
      if (recordValue === null || recordValue === undefined) return false;

      if (isDate) {
        return recordValue && moment(recordValue).isValid()
          ? moment(recordValue).format('DD/MM/YYYY') === value
          : false;
      }
      return recordValue.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  });

  const columns = [
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
      align: 'center',
      width: 120,
      render: (date) => (date && moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : '-'),
      ...getColumnSearchProps('date', 'Data', true),
      sorter: (a, b) => {
        const dateA = moment(a.date);
        const dateB = moment(b.date);
        if (!dateA.isValid() && !dateB.isValid()) return 0;
        if (!dateA.isValid()) return 1;
        if (!dateB.isValid()) return -1;
        return dateA.unix() - dateB.unix();
      },
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      width: 110,
      render: (type) => (type === 'Service' ? 'Serviço' : type),
      filters: [
        { text: 'Serviço', value: 'Service' },
        { text: 'CT', value: 'CT' },
        { text: 'In Company', value: 'In Company' },
        { text: 'EAD', value: 'EAD' },
      ],
      filterSearch: true,
      onFilter: (value, record) => record.type === value,
      sorter: (a, b) => (a.type || '').localeCompare(b.type || ''),
    },
    {
      title: 'Aprovado',
      dataIndex: 'approved',
      key: 'approved',
      align: 'center',
      width: '10%',
      render: (approved) =>
        approved ? (
          <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
        ) : (
          <CloseCircleOutlined style={{ color: '#fc5d20', fontSize: 20 }} />
        ),
      filters: [
        {
          text: (
            <>
              <CheckCircleOutlined style={{ marginRight: 8, color: '#3BB537' }} />
              Aprovado
            </>
          ),
          value: true,
        },
        {
          text: (
            <>
              <CloseCircleOutlined style={{ marginRight: 8, color: '#FC5D20' }} />
              Pendente
            </>
          ),
          value: false,
        },
      ],
      filterSearch: false,
      onFilter: (value, record) => record.approved === value,
      sorter: (a, b) => {
        if (a.approved === b.approved) return 0;
        return a.approved ? -1 : 1;
      },
    },
    {
      title: 'Produto',
      dataIndex: 'product',
      key: 'product',
      width: '30%',
      ...getColumnSearchProps('product', 'Produto'),
      sorter: (a, b) => (a.product || '').localeCompare(b.product || ''),
    },
    {
      title: 'Observação',
      dataIndex: 'notes',
      key: 'notes',
      width: 'auto',
    },
    {
      title: 'CT',
      dataIndex: 'trainingCenterName',
      key: 'trainingCenterName',
      width: 150,
      render: (text) => text,
      filters:
        slots && slots.length > 0
          ? [...new Set(slots.map((item) => item.trainingCenterName))]
              .sort((a, b) => (a || '').localeCompare(b || ''))
              .map((name) => ({ text: name || '(Vazio)', value: name || null }))
          : [],
      filterSearch: true,
      onFilter: (value, record) => record.trainingCenterName === value,
      sorter: (a, b) => (a.trainingCenterName || '').localeCompare(b.trainingCenterName || ''),
    },
  ];

  const submit = async (values) => {
    setLoading(true);
    try {
      const data = {
        ...values,
        date: moment(getCurrentDate()).hour(12).minute(59).second(59).millisecond(999),
        approved: false,
        trainingCenterId: ctId,
      };
      const { data: newSlotsFromApi } = await api.post('/Slot', data);
      await SchedulingFunctions.sendNotificationToApprovers();
      const newSlotsProcessed = processSlots(newSlotsFromApi);
      setSlots((prevSlots) => processSlots([...prevSlots, ...newSlotsProcessed]));
      message.success('Solicitação de slots enviada!');
      form.resetFields();
    } catch (error) {
      Utils.logError(error);
      message.error('Falha ao solicitar slots!');
    } finally {
      setLoading(false);
    }
  };

  const approveSlots = async () => {
    setLoading(true);

    const idsToApprove = selectedItems.filter(({ approved }) => !approved).map(({ id }) => id);

    try {
      await api.put(`/Slot?ids=${idsToApprove.toString()}`);

      const updatedSlots = slots.map((item) => {
        if (idsToApprove.includes(item.id)) {
          return { ...item, approved: true };
        }
        return item;
      });
      const processedApprovedSlots = processSlots(updatedSlots);
      setSlots(processedApprovedSlots);
      callSlotGeneration(trainingCenter, null, null, null, processedApprovedSlots);

      formList.resetFields();
      setSelectedItems([]);
      message.success('Slots aprovados!');
    } catch (error) {
      Utils.logError(error);
      message.error('Falha ao aprovar slots!');
    } finally {
      setLoading(false);
    }
  };

  const deleteSlots = async () => {
    setLoading(true);
    const idsToDelete = selectedItems.map(({ id }) => id);

    try {
      await api.delete(`/Slot?ids=${idsToDelete.toString()}`);

      const remainingSlots = slots.filter(({ id }) => !idsToDelete.includes(id));
      const processedRemainingSlots = processSlots(remainingSlots);
      setSlots(processedRemainingSlots);
      callSlotGeneration(trainingCenter, null, null, null, processedRemainingSlots);

      formList.resetFields();
      setSelectedItems([]);
      message.success('Slots removidos!');
    } catch (error) {
      Utils.logError(error);
      message.error('Falha ao remover slots!');
    } finally {
      setLoading(false);
    }
  };

  const calculateMaxSlots = () => {
    const type = form.getFieldValue('type');
    const currentDateStr = getCurrentDate();

    const slotsCt =
      slots?.filter(
        ({ type: slotType, date }) =>
          slotType === 'CT' && moment(date).format('YYYY-MM-DD') === currentDateStr
      )?.length ?? 0;
    const slotsInCompany =
      slots?.filter(
        ({ type: slotType, date }) =>
          slotType === 'In Company' && moment(date).format('YYYY-MM-DD') === currentDateStr
      )?.length ?? 0;
    const slotsEad =
      slots?.filter(
        ({ type: slotType, date }) =>
          slotType === 'EAD' && moment(date).format('YYYY-MM-DD') === currentDateStr
      )?.length ?? 0;
    const slotsService =
      slots?.filter(
        ({ type: slotType, date }) =>
          slotType === 'Service' && moment(date).format('YYYY-MM-DD') === currentDateStr
      )?.length ?? 0;

    switch (type) {
      case 'CT':
        setMaxSlots(
          (trainingCenter?.ctQtyColumns ?? 0) * 5 - (trainingCenter?.ctQtySlots ?? 0) - slotsCt
        );
        break;
      case 'In Company':
        setMaxSlots(
          (trainingCenter?.inCompanyQtyColumns ?? 0) * 5 -
            (trainingCenter?.inCompanyQtySlots ?? 0) -
            slotsInCompany
        );
        break;
      case 'EAD':
        setMaxSlots(
          (trainingCenter?.eadQtyColumns ?? 0) * 5 - (trainingCenter?.eadQtySlots ?? 0) - slotsEad
        );
        break;
      case 'Service':
        setMaxSlots(
          (trainingCenter?.serviceQtyColumns ?? 0) * 5 -
            (trainingCenter?.serviceQtySlots ?? 0) -
            slotsService
        );
        break;
      default:
        setMaxSlots(0);
        break;
    }
  };

  useEffect(() => {
    const options = [];
    if (trainingCenter?.ctQtyColumns > 0) {
      options.push({
        value: 'CT',
        label: 'CT',
      });
    }
    if (trainingCenter?.inCompanyQtyColumns > 0) {
      options.push({
        value: 'In Company',
        label: 'In Company',
      });
    }
    if (trainingCenter?.eadQtyColumns > 0) {
      options.push({
        value: 'EAD',
        label: 'EAD',
      });
    }
    if (trainingCenter?.serviceQtyColumns > 0) {
      options.push({
        value: 'Service',
        label: 'Serviço',
      });
    }
    setResourceOptions(options);
  }, [trainingCenter]);

  return (
    <Popup
      ref={newSlotPopupRef}
      className="new-slot-popup"
      title={`Adicionar Slot - (${moment(getCurrentDate()).format('DD/MM/YYYY')})`}
      hideOnOutsideClick={false}
      onHidden={() => {
        form.resetFields();
      }}
      copyRootClassesToWrapper
      width="80%"
      height="100vh"
    >
      <ScrollView width="100%" height="100%" className="new-slot-scrollview-content-wrapper">
        <Form
          form={form}
          disabled={loading}
          name="newSlotPopup"
          layout="vertical"
          autoComplete="off"
          onFinish={submit}
        >
          <Row gutter={[24]}>
            <Col span={8}>
              <Form.Item
                label="Recurso"
                name="type"
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Radio.Group
                  options={resourceOptions}
                  optionType="button"
                  buttonStyle="solid"
                  disabled={loading}
                  onChange={calculateMaxSlots}
                />
              </Form.Item>
              <Form.Item
                label="Qtd. Slots"
                name="qtySlots"
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <InputNumber min={1} max={maxSlots} />
              </Form.Item>
              <Form.Item
                label="Produto"
                name="product"
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Select
                  placeholder="Selecione"
                  optionFilterProp="label"
                  dropdownStyle={{ borderRadius: 16, zIndex: 9999 }}
                  options={bitrixProducts}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item label="Observação" name="notes">
                <TextArea rows={9} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button loading={loading} block type="primary" htmlType="submit">
                Salvar
              </Button>
            </Col>
          </Row>
        </Form>

        <Divider className="configuration-divider" orientation="left" />

        <div className="new-slot-footer" style={{ display: showFooterButtons ? 'block' : 'none' }}>
          <Button
            className="approve-button"
            type="default"
            icon={<CheckCircleOutlined />}
            onClick={approveSlots}
            disabled={loading || selectedItems?.filter(({ approved }) => !approved)?.length === 0}
          >
            Aprovar
          </Button>
          <Popconfirm
            title="Tem certeza que deseja deletar estes slots?"
            onConfirm={deleteSlots}
            okText="Sim"
            cancelText="Não"
            overlayStyle={{
              zIndex: 9999,
            }}
            disabled={loading || selectedItems.length === 0}
          >
            <Button
              className="delete-button"
              type="default"
              danger
              style={{ marginLeft: 10 }}
              icon={<DeleteOutlined />}
              disabled={loading || selectedItems.length === 0}
            >
              Deletar
            </Button>
          </Popconfirm>
        </div>

        <Table
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys: selectedItems.map((item) => item.key),
            onChange: (_selectedRowKeys, selectedRows) => {
              setSelectedItems(selectedRows);
            },
          }}
          id="id"
          columns={columns}
          dataSource={slots}
          pagination={{
            position: ['bottomCenter'],
            defaultPageSize: 10,
            pageSizeOptions: [10, 20, 30, 50, 100],
            showSizeChanger: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
          }}
          style={{
            marginTop: 10,
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        />
      </ScrollView>
    </Popup>
  );
}
